export default __webpack_public_path__ + "images/onboarding-slide-5.926f4f4cae808713af6cfa16b1728282.svg";